<template>
  <div v-if="!loading" class="custom-margin-full-page">
    <global-snack-bar-desktop></global-snack-bar-desktop>
    <v-row v-if="privateSessions.length">
      <v-col cols="12" class="title-sessions">
        جلسات آنلاین خصوصی شما
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="privateSessions"
                :items-per-page="20"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="success" @click="enterClass(item.id,item.instructor_id)">mdi-login</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="title-sessions">
        جلسات آنلاین شما
      </v-col>
      <v-col cols="12" v-if="!sessions.length">
        نام شما در دوره ای ثبت نیست. برای دیدن درس ها ابتدا باید دوره مورد نظر را انتخاب و اشتراک آن را تهیه کنید.
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="sessions"
                :items-per-page="20"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="success" @click="enterClass(item.id,item.instructor_id)">mdi-login</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GlobalSnackBarDesktop from "@/components/Components/Desktop/Notification/GlobalSnackBarDesktop.vue";

export default {
  name: "MySessionsMobile",
  components: {GlobalSnackBarDesktop},
  data() {
    return {
      loading: true,
      sessions: [],
      privateSessions:[],
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'شناسه کلاس', value: 'online_class_id', align: 'center'},
        {text: 'عنوان', value: 'title', align: 'center'},
        {text: 'زمان شروع کلاس', value: 'starts_at_fa', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  methods: {
    getPrivateSessions(){
      window.axios.get('student/session/private/index/'+ '?per_page=1000').then((res) => {
        this.privateSessions = res.data.data.data
        this.loading = false
      })
    },
    getSessions() {
      window.axios.get('student/session/index/' + this.$route.params.classId + '?per_page=1000').then((res) => {
        this.sessions = res.data.data.data
        this.loading = false
      })
          .catch((err) => {
            this.loading = false
            if (err.response.status === 400) {
              this.openSnackbar(err.response.data.message, '#F1416C')
            }
          })
    },
    enterClass(sessionId,instructorId) {
      this.$router.push('/online-session/' + sessionId + '/' + instructorId)
    }
  },
  mounted() {
    this.getPrivateSessions()
    this.getSessions()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 8vw 0 8vw;
}

.title-sessions {
  margin-top: 5vh;
  margin-bottom: 3vh;
  font-size: 4.5vw !important;
}

.session-card {
  cursor: pointer;
  border-radius: 15px;
  background-color: #1ab69d;
}

.white-background {
  background-color: white;
}

.session-cover {
  border-radius: 15px;
}

.buy-btn {
  letter-spacing: normal;
  color: white;
  border-radius: 15px;
  width: 200px;
  padding: 25px !important;
}

.custom-shape-red-session {
  position: absolute;
  top: 20vh;
  margin-right: -2vw;
}

.custom-shape-circle-red-session {
  transform: rotate(15deg);
  position: absolute;
  top: 8vh;
  right: 8vw;
}
</style>